import { Sun, Moon } from 'lucide-react';
import { useTheme } from '../context/ThemeContext';

interface ThemeToggleProps {
  position?: 'fixed' | 'relative';
  /** On mobile, show only the icon (no "Light"/"Dark" text) for a compact top-right control */
  iconOnly?: boolean;
}

export function ThemeToggle({ position = 'relative', iconOnly = false }: ThemeToggleProps) {
  const { theme, toggleTheme } = useTheme();

  const positionClasses =
    position === 'fixed' ? 'fixed top-6 right-6 z-50' : '';

  return (
    <button
      onClick={toggleTheme}
      className={`${positionClasses} flex items-center justify-center gap-2 px-3 py-2 text-sm font-medium bg-transparent border-0 rounded-xl hover:bg-black/5 dark:hover:bg-white/10 transition-colors cursor-pointer text-gray-800 dark:text-white min-w-[44px] min-h-[44px] touch-manipulation ${iconOnly ? 'w-11 h-11 p-0' : 'h-[36px]'}`}
      title={`Switch to ${theme === 'light' ? 'dark' : 'light'} mode`}
      aria-label={`Switch to ${theme === 'light' ? 'dark' : 'light'} mode`}
    >
      {theme === 'light' ? (
        <Sun className="w-5 h-5 flex-shrink-0 opacity-60" />
      ) : (
        <Moon className="w-5 h-5 flex-shrink-0 opacity-60" />
      )}
      {!iconOnly && (
        <span className="hidden sm:inline">
          {theme === 'light' ? 'Light' : 'Dark'}
        </span>
      )}
    </button>
  );
}
